import React from 'react';

export function ContentSection({ title, children, className = '' }) {
  return (
    <section className={`mb-12 ${className}`}>
      {title && <h2 className="mb-4 text-xl font-bold text-primary md:text-2xl">{title}</h2>}
      {children}
    </section>
  );
}

export function InfoList({ items, bullet = '•' }) {
  return (
    <ul className="space-y-3">
      {items.map((item) => (
        <li key={item} className="relative pl-6 leading-relaxed text-mist">
          <span className="absolute left-0 text-primary">{bullet}</span>
          {item}
        </li>
      ))}
    </ul>
  );
}

export function InfoCard({ icon, title, children }) {
  return (
    <div className="glass-card p-5 md:p-6">
      <h3 className="mb-3 font-bold text-white">
        {icon && <span className="mr-2">{icon}</span>}
        {title}
      </h3>
      {children}
    </div>
  );
}

export function Callout({ children, variant = 'primary' }) {
  const styles = variant === 'warn'
    ? 'border-amber-500/30 bg-amber-500/10'
    : 'border-primary/25 bg-primary/10';

  return (
    <div className={`mt-5 rounded-2xl border p-5 ${styles}`}>
      <p className="m-0 leading-relaxed text-mist">{children}</p>
    </div>
  );
}
